var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65345 17.5003L5.90346 17.8337C7.02846 19.3337 9.27846 19.3337 10.4035 17.8337L10.6535 17.5003M1.63914 12.9583L1.72527 13.1359C2.27841 14.2762 3.43443 15.0003 4.70185 15.0003H11.5525C12.6386 15.0003 13.6494 14.4455 14.2326 13.5292C15.0557 12.2358 14.8377 10.5391 13.7143 9.49577L13.6777 9.4618C12.915 8.75346 12.5395 7.72152 12.6686 6.68865L12.7225 6.25787C13.0272 3.82015 11.1264 1.66699 8.6697 1.66699H7.25061C4.79691 1.66699 2.89846 3.81753 3.20281 6.25227L3.26894 6.78131C3.39072 7.75558 3.03484 8.72874 2.31327 9.3946C1.32767 10.3041 1.05384 11.7517 1.63914 12.9583Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.00c26e4ac9f0145084958597d3f0d5f6.svg";
export { ForwardRef as ReactComponent };